import React from "react";
import PropTypes from "prop-types";
import { Button as B } from "@learningblocks/shared-components";

import style from "./style.module.scss";

export function Button(props) {
  const renderIcon = () =>
    props.disabled ? props.disabledicon : props.normalicon;

  return (
    <B {...props} className={`${style.stepperButton} ${props.className}`}>
      {renderIcon()}
    </B>
  );
}

Button.propTypes = {
  /**
   * specifies if button is disabled
   */
  disabled: PropTypes.bool,
  /**
   * button contents when it is not disabled
   */
  normalicon: PropTypes.element,
  /**
   * button contents when it is disabled
   */
  disabledicon: PropTypes.element,
};
